<!--
  本页面为用户新增和用户修改界面 * 通过pageType字段来区分：1新增，2修改 
  @Last Modified by: lichong * @Last Modified time: 2020-01-06 14:31:44
-->
<template>
  <div ref="pageView" class="page-view container-view">
    <!-- title -->
    <section class="title-section fixed-view">
      <e6-title>
        {{ pageTitle }}
        <template slot="breadcrumb">
          <e6-breadcrumb :breadcrumbs="breadcrumbs"></e6-breadcrumb>
        </template>
      </e6-title>
    </section>
    <!-- title end -->
    <!-- content -->
    <section
      class="content-section"
      :style="{ height: resizeViewHeight + 'px' }"
    >
      <div class="form-wrapper">
        <e6-form-extend
          class="e6-from--column-2"
          ref="formExtend"
          :formExtend="formExtend"
          :inline="true"
          :submitLoadingState="loadingState"
          label-width="200px"
          @submitForm="handleSubmitForm"
          @resetForm="handleResetForm"
        >
          <template slot-scope="slotForms">
            <el-form-item
              prop="forms.userName"
              :label="$t('_private.label.userName')"
              :rules="[
                {
                  required: true,
                  message: $t('_private.rule.userName'),
                  trigger: 'blur',
                },
              ]"
            >
              <el-input
                v-model="slotForms.forms.userName"
                :placeholder="$t('_private.placeholder.userName')"
                clearable
              ></el-input>
            </el-form-item>
            <el-form-item
              prop="forms.userCode"
              :label="$t('_private.label.userCode')"
              :rules="userCodeRules"
            >
              <el-input
                v-model="slotForms.forms.userCode"
                :placeholder="$t('_private.placeholder.userCode')"
                clearable
                :disabled="userCodeDisabled"
              ></el-input>
            </el-form-item>
            <el-form-item
              prop="forms.webgisPassword"
              :label="$t('_private.label.password')"
              :rules="webgisPasswordRules"
            >
              <el-input
                v-model="slotForms.forms.webgisPassword"
                :placeholder="$t('_private.placeholder.password')"
                type="password"
                clearable
              ></el-input>
            </el-form-item>
            <el-form-item
              prop="forms.confirmWebgisPassword"
              :label="$t('_private.label.confirmPassword')"
              :rules="confirmWebgisPasswordRules"
            >
              <el-input
                v-model="slotForms.forms.confirmWebgisPassword"
                :placeholder="$t('_private.placeholder.confirmPassword')"
                type="password"
                clearable
              ></el-input>
            </el-form-item>
            <el-form-item
              prop="forms.orgId"
              :label="$t('_private.label.department')"
              :rules="[
                {
                  required: true,
                  message: $t('_private.rule.department'),
                  trigger: 'change',
                },
              ]"
            >
              <e6Select
                ref="organization"
                :selectedListDefault="orgId"
                :dataList="organizations"
                placeholder="请选择"
                slotTemplate="tree"
                filterable
                widthData="240px"
                @multipleSelect="handleSelectOrganization"
              >
              </e6Select>
            </el-form-item>
            <el-form-item
              prop="forms.roleIds"
              :label="$t('_private.label.role')"
              :rules="[
                {
                  required: true,
                  message: $t('_private.rule.role'),
                  trigger: 'change',
                },
              ]"
            >
              <el-select
                v-model="slotForms.forms.roleIds"
                :placeholder="$t('_private.placeholder.role')"
              >
                <el-option
                  v-for="item in roleList"
                  :key="item.value"
                  :label="item.roleName"
                  :value="item.roleId"
                ></el-option>
              </el-select>
            </el-form-item>

            <el-form-item
              :label="$t('_private.label.phone')"
              prop="forms.phone"
            >
              <el-input
                v-model="slotForms.forms.phone1"
                :placeholder="$t('_private.placeholder.phone')"
                clearable
              ></el-input>
            </el-form-item>
            <el-form-item
              :label="$t('_private.label.telephone')"
              prop="forms.telephone"
            >
              <el-input
                v-model="slotForms.forms.phone"
                :placeholder="$t('_private.placeholder.telephone')"
                clearable
              ></el-input>
            </el-form-item>
            <el-form-item
              :label="$t('_private.label.email')"
              prop="forms.emailAddr"
              :rules="[
                {
                  type: 'email',
                  message: '请输入正确的邮箱地址',
                  trigger: ['blur', 'change'],
                },
              ]"
            >
              <el-input
                v-model="slotForms.forms.emailAddr"
                :placeholder="$t('_private.placeholder.email')"
                clearable
              ></el-input>
            </el-form-item>
            <el-form-item
              prop="forms.isAbleUse"
              label="是否启用"
              :rules="[
                { required: true, message: '是否有效必填', trigger: 'change' },
              ]"
            >
              <el-radio-group v-model="slotForms.forms.isAbleUse">
                <el-radio :label="1">启用</el-radio>
                <el-radio :label="0">禁用</el-radio>
              </el-radio-group>
            </el-form-item>
            <el-form-item :label="$t('_private.label.address')">
              <el-input
                v-model="slotForms.forms.address"
                :placeholder="$t('_private.placeholder.address')"
                clearable
              ></el-input>
            </el-form-item>
            <el-form-item
              label="用户类型"
              prop="forms.userSourceType"
              :rules="[
                { required: true, message: '用户类型必填', trigger: 'change' },
              ]"
            >
              <el-radio-group
                v-model="slotForms.forms.userSourceType"
                @change="userSourceTypeChange"
              >
                <el-radio :label="4">政府人员</el-radio>
                <!--<el-radio :label="5">服务商人员</el-radio>-->
                <el-radio :label="6">企业人员</el-radio>
              </el-radio-group>
            </el-form-item>
            <el-form-item
              prop="forms.comparyIds"
              label="企业信息"
              :rules="[
                { required: true, message: '请选择关联企业', trigger: 'blur' },
              ]"
            >
              <e6Select
                ref="comparys"
                :selectedListDefault="comparyIds"
                :dataList="allComparys"
                placeholder="请选择关联企业"
                slotTemplate="tree"
                filterable
                widthData="240px"
                placement="bottom"
                issingleleaf
                multiple
                @multipleSelect="handleSelectCompary"
              >
              </e6Select>
            </el-form-item>
            <el-form-item
              v-if="slotForms.forms.userSourceType == 4"
              prop="forms.comparyIds"
              label="冷链监控看板名称"
              :rules="[
                {
                  required: true,
                  message: '冷链监控看板名称必填',
                  trigger: 'blur',
                },
              ]"
            >
              <el-input
                v-model="slotForms.forms.coldName"
                placeholder="请输入"
                clearable
              ></el-input>
            </el-form-item>
            <el-form-item label="系统名称扩展">
              <el-input
                v-model="slotForms.forms.subModuleTitle"
                placeholder="系统名称扩展"
                clearable
              ></el-input>
            </el-form-item>
            <el-form-item
              prop="forms.regionCode"
              label="冷链监控看板城市"
              v-if="slotForms.forms.userSourceType == 4"
            >
              <echarts-city
                :bin="slotForms.forms.regionCode"
                ref="echartsCity"
                :format="['市']"
                :clearable="true"
                placeholder="请选择地区"
                @selected="citySelect"
              ></echarts-city>
            </el-form-item>
            <el-form-item class="textarea" :label="$t('_private.label.remark')">
              <el-input
                type="textarea"
                :rows="2"
                v-model="slotForms.forms.remark"
                :placeholder="$t('_private.placeholder.remark')"
                clearable
              ></el-input>
            </el-form-item>
          </template>
          <template slot="submit">{{ $t("_private.button.submit") }}</template>
          <template slot="reset">{{ $t("_private.button.return") }}</template>
        </e6-form-extend>
      </div>
    </section>
    <!-- content end -->
  </div>
</template>

<script>
import echartsCity from "@/components/echartsCity";
import {
  FetchGetUserAllRole,
  FetchGetExtColumn,
  FetchFindUserByPeopleId,
  FetchSaveUser,
  FetchAllComparysAndCounty,
} from "_private/api/systemSetting/userManage";

import { mapGetters, mapActions } from "vuex";
import resizeListener from "_private/mixins/resizeListener";
import validate from "_private/utils/validate";
import { mergeFormExtend } from "_private/utils/merge";

export default {
  mixins: [resizeListener],
  components: { echartsCity },
  data() {
    let checkPassword = (rule, value, callback) => {
      if (value === "") {
        callback(new Error(this.$t("_private.rule.password")));
      } else if (value !== this.formExtend.forms.webgisPassword) {
        callback(new Error(this.$t("_private.rule.confirmPassword")));
      } else {
        callback();
      }
    };
    return {
      allComparys: [],
      breadcrumbs: [
        {
          path: "/home",
          isRedirect: true,
          meta: {
            title: this.$t("_private.title.home"),
          },
        },
        {
          path: "/systemSettingUserManageList",
          isRedirect: true,
          meta: {
            title: this.$t("_private.title.userManage"),
          },
        },
      ],
      formExtend: {
        forms: {
          userName: "",
          userCode: "",
          webgisPassword: "",
          confirmWebgisPassword: "",
          orgId: "",
          roleIds: "",
          phone1: "",
          phone: "",
          emailAddr: "",
          address: "",
          isAbleUse: 1,
          comparyIds: [],
          remark: "",
          userSourceType: "",
          subModuleTitle: "",
          coldName: "城市冷链配送监控看板",
          regionCode: 440100,
        },
        extends: [],
      },
      checkPassword: checkPassword,
      roleList: [],
      orgId: [],
      comparyIds: [],
      loadingState: false,
      comparyMultiple: false,
    };
  },
  computed: {
    ...mapGetters(["moduleId", "organizations"]),
    pageType() {
      return this.$route.query.pageType ? this.$route.query.pageType : "1";
    },
    pageTitle() {
      const pageTitle =
        this.pageType === "1"
          ? this.$t("_private.title.addUser")
          : this.$t("_private.title.editUser");
      return pageTitle;
    },
    userId() {
      return this.$route.query.userId;
    },
    peopleId() {
      return this.$route.query.peopleId;
    },
    userCodeRules() {
      return this.pageType === "1"
        ? [
            {
              required: true,
              message: this.$t("_private.rule.userCode"),
              trigger: "blur",
            },
            { validator: validate.CheckUserCodeIsExist, trigger: "blur" },
          ]
        : [];
    },
    userCodeDisabled() {
      return this.pageType === "1" ? false : true;
    },
    webgisPasswordRules() {
      let webgisPasswordRules = [];
      if (this.pageType === "1") {
        webgisPasswordRules = [
          {
            required: true,
            message: this.$t("_private.rule.password"),
            trigger: "blur",
          },
          { validator: validate.CheckVehicleIdentificationNo, trigger: "blur" },
        ];
      } else {
        webgisPasswordRules = [
          {
            required: true,
            message: this.$t("_private.rule.password"),
            trigger: "blur",
          },
        ];
      }
      return webgisPasswordRules;
    },
    confirmWebgisPasswordRules() {
      let confirmWebgisPasswordRules = [];
      if (this.pageType === "1") {
        confirmWebgisPasswordRules = [
          {
            required: true,
            message: this.$t("_private.rule.confirmPassword"),
            trigger: "blur",
          },
          { validator: validate.CheckVehicleIdentificationNo, trigger: "blur" },
          { validator: this.checkPassword, trigger: "blur" },
        ];
      } else {
        confirmWebgisPasswordRules = [
          {
            required: true,
            message: this.$t("_private.rule.confirmPassword"),
            trigger: "blur",
          },
          { validator: this.checkPassword, trigger: "blur" },
        ];
      }
      return confirmWebgisPasswordRules;
    },
  },
  created() {
    let breadcrumb = {
      path: "/systemSettingUserManageEdit",
      isRedirect: false,
      meta: {
        title: this.pageTitle,
      },
    };
    this.breadcrumbs.push(breadcrumb);
    this.initData();
    this.setOrganizationAct();
  },
  methods: {
    ...mapActions(["setOrganizationAct"]),
    // 初始化数据
    initData() {
      let apiList = [this.FetchGetUserAllRole(), this.initAllComparys()];
      Promise.all(apiList)
        .then(([res1, res2]) => {
          if (res1 && res2) {
            let FetchGetExtColumnData = {};
            FetchGetExtColumnData.edit = true;
            FetchGetExtColumnData.moduleId = this.moduleId;
            if (this.pageType === "2") {
              FetchGetExtColumnData.primaryKeyId = this.userId;
              this.FetchFindUserByPeopleId({ peopleId: this.peopleId });
            }
            this.FetchGetExtColumn(FetchGetExtColumnData);
          }
        })
        .catch((error) => {
          console.log(error);
        });
    },
    // citySelect
    citySelect(val) {
      this.formExtend.forms.regionCode = val.bin;
    },
    // 获取角色列表
    FetchGetUserAllRole() {
      return new Promise((resolve, reject) => {
        FetchGetUserAllRole()
          .then((response) => {
            if (response.result && Array.isArray(response.result)) {
              this.roleList = response.result;
            }
            resolve(true);
          })
          .catch((error) => {
            console.log(error);
            reject(error);
          });
      });
    },
    // 获取扩展字段
    FetchGetExtColumn(data) {
      FetchGetExtColumn(data)
        .then((response) => {
          if (response.result && Array.isArray(response.result)) {
            this.formExtend.extends.push(...response.result);
          }
        })
        .catch((error) => {
          console.log(error);
        });
    },
    // 修改用户时，先获取用户信息
    FetchFindUserByPeopleId(data) {
      FetchFindUserByPeopleId(data)
        .then((response) => {
          response.result.roleIds = parseInt(response.result.roleIds);
          let selectTree = response.result.orgId.toString().split(",");
          this.orgId = selectTree;
          let selectComparyTree = response.result.comparyIds;
          this.comparyIds = selectComparyTree;
          response.result.confirmWebgisPassword =
            response.result.webgisPassword;
          this.formExtend.forms = Object.assign({}, response.result);

          // if (response.result.userSourceType == 6) {
          //   this.comparyMultiple = false;
          //   this.formExtend.forms.comparyIds = parseInt(
          //     response.result.comparyIds[0]
          //   );
          // } else {
          //   this.comparyMultiple = true;
          // }
        })
        .catch((error) => {
          console.log(error);
        });
    },
    // 选择企业
    handleSelectCompary(val) {
      const tempArr = val.map((v) => v.id);
      this.formExtend.forms.comparyIds = tempArr;
    },
    // 新增，修改用户
    FetchSaveUser(data) {
      FetchSaveUser(data)
        .then((response) => {
          this.submitCallback(response);
        })
        .catch((error) => {
          console.log(error);
        });
    },
    handleSelectOrganization(val) {
      this.formExtend.forms.orgId = val.length ? val[0].id : "";
    },
    // 新增、修改用户完成时的回调函数
    submitCallback(data) {
      let type = data.code === 1 ? "success" : "error";
      let message = data.message;
      this.$message({
        showClose: true,
        message: message,
        type: type,
        duration: 2000,
        onClose: () => {
          if (type === "success") {
            this.$router.push("/systemSettingUserManageList");
          }
          this.loadingState = false;
        },
      });
    },
    /**
     *  初始化企业
     */
    initAllComparys() {
      return new Promise((resolve, reject) => {
        FetchAllComparysAndCounty()
          .then((response) => {
            if (
              response.result &&
              response.result &&
              Array.isArray(response.result)
            ) {
              this.allComparys = response.result;
              this.$nextTick(() => {});
            }
            resolve(true);
          })
          .catch((error) => {
            console.log(error);
            reject(error);
          });
      });
    },
    // 提交
    handleSubmitForm(valid) {
      if (valid) {
        let data = {};
        if (this.pageType === "1") {
          data = mergeFormExtend(this.formExtend);
        } else {
          data = Object.assign(mergeFormExtend(this.formExtend), {
            peopleId: this.peopleId,
          });
        }
        data.moduleId = this.moduleId;

        this.loadingState = true;
        this.FetchSaveUser(data);
      }
    },
    // 取消
    handleResetForm() {
      this.$router.push("/systemSettingUserManageList");
    },
    userSourceTypeChange(val) {
      this.formExtend.forms.comparyIds = null;
      this.$nextTick(() => {
        if (val == 6) {
          this.comparyMultiple = false;
        } else {
          this.comparyMultiple = true;
        }
      });
    },
  },
};
</script>

<style lang="scss" scoped>
.page-view {
  height: 100%;
}

.title-section {
  padding: 15px 20px 10px;
}

.content-section {
  overflow: auto;
}

.content-section {
  .form-wrapper {
    padding-top: 20px;
    margin: 0 20px;
    background-color: #fff;
  }
}

/deep/ .e6-from--column-2 {
  .el-input {
    width: 240px;
  }
  .el-textarea__inner {
    width: 240px;
  }
}
</style>
